<template>
  <div class="learningReport2" id="learningReport">
    <div style="background: #fff; min-height: 600px">
      <div class="evaluationPeport_main" v-if="reportId&&part1Data.test_id!==''">
        <div class="title">{{ user.realname}}学习力测评报告解读</div>
        <!-- 综合鑫都指数 -->
        <div>
          <div class="partTitle">综合信度指数</div>
          <div class="line"></div>
          <table>
            <tr>
              <th>综合信度指数</th>
              <td colspan="2">
                {{
                  reliability_index.comprehensiveReliabilityIndex
                }}（参考值：70↑）
              </td>
            </tr>
            <tr>
              <th>作答起止时间</th>
              <td colspan="2">
                {{ reliability_index.answerStartTime }} &nbsp;—&nbsp;
                {{ reliability_index.answerEndTime }}
              </td>
            </tr>
            <tr>
              <th rowspan="3">作答时间</th>
              <td>限时能力类测试</td>
              <td>
                {{ reliability_index.limitedTime }}分钟
                （参考时间：12.7-36.1分钟）
              </td>
            </tr>
            <tr>
              <td>非限时能力类测试</td>
              <td>
                {{ reliability_index.unlimitedTime }}分钟
                （参考时间：4.3-36分钟）
              </td>
            </tr>
            <tr>
              <td>量表类测试</td>
              <td>
                {{ reliability_index.questionnaireTime }}分钟
                （参考时间：5.9-15.6分钟）
              </td>
            </tr>
            <tr>
              <th>作答一致性</th>
              <td colspan="2">
                {{ reliability_index.consistency }}（参考值：0.7↑）
              </td>
            </tr>
            <tr>
              <th>作答规律性</th>
              <td colspan="2">{{ reliability_index.regularity }}次</td>
            </tr>
            <tr>
              <th>作答趋中性</th>
              <td colspan="2">{{ reliability_index.neutrality }}</td>
            </tr>
            <tr>
              <th>社会称许性</th>
              <td colspan="2">
                {{ reliability_index.cehuang }}（参考值：0.7↓）
              </td>
            </tr>
          </table>
        </div>
        <div>
          <PagePart5
                v-if="part3Strategy.constructor === Object && part3style.constructor === Object"  :strategyNorm="part3Strategy.norm" :strategyComment="part3Strategy.comment" :styleNorm="part3style.norm" :styleComment="part3style.comment"
                :total="total"
                :core="core"
                :normData="normData.default"
                :normDataDongli="normDataDongli"
                :normDataMind="normDataMind"
                :part1Norm="part1Norm"
                :part3StrategyNorm="part3StrategyNorm"
                :part1Total="part1Total"
                :part2Total="part2Total"
                :part3Total="part3Total"
                :part2norm="part2Data.norm" :part2comment="part2Data.comment"
                :part4norm="part4Data.norm" :part4comment="part4Data.comment"
                :studentId="studentId"
            ></PagePart5>         
        </div>
      </div>
      <div v-else class="noContent">
        <NoContent></NoContent>
      </div>
    </div>
  </div>
</template>
<script>
import NoContent from "@/components/NoContent.vue";
import PagePart5 from './components2/PagePart_edit.vue';//核心结果
export default {
  components: { NoContent,PagePart5 },
  data() {
    return {
      zonghezhishu:'',
      editData:{},
      userName: "",
      SchoolId: "",
      version: "",
      reportId: "",
    //   reliability_index: {}, //综合信度指数
      total: [], // 学习力总体得分
      normData:{},
      core:{},
      part1Data:[],
      isShowLogo: false,
            headerLogo: '',
            isLoading: true,
            isDownloading: false, //是否正在下载
            totalPages: 1, //总页数
            currentPage: 0,//当前页
            // isDownlondPdf: true

            // 获取报告时用的参数
            userName: '',
            schoolID: '',
            startTime: '',
            endTime: '',

            htmlTitle: '',
            reportData: null,
            isHadReport: false,
            user: {},
            core: {},
            reliability_index: {},
            normData:{},
            part1Data: [],
            part2Data: [],
            part3Strategy: [],
            part3style: [],
            part4Data: [],
            total: [],
            part1Index: 0,
            part2Index: 0,
            part3Index: 0,
            part4Index: 0,
            listData: [],
            studentId: sessionStorage.getItem('myStudentStudentId')
    };
  },
  computed: {
    normDataDongli() {
            let user = this.user;
            if(user.grade=='高三') {
                return this.normData.power.three;
            }else if(user.grade=='高二') {
                return this.normData.power.two;
            }else if(user.grade=='高一') {
                return this.normData.power.one;
            }else if(user.grade=='成年人'){
                return this.normData.power.three;
            }else {
                return this.normData.power.one;
            }
        },
        normDataMind() {
            return this.normData.mind;
        },
        part1Total() {
            if(this.part1Data.constructor === Object) {
                return this.part1Data.norm[9];
            }else {
                return null;
            }
        },
        part2Total() {
            if(this.part2Data.constructor === Object) {
                return this.part2Data.norm[4];
            }else {
                return null;
            }
        },
        part3Total() {
            if(this.part3Strategy.constructor === Object) {
                return this.part3Strategy.norm[12];
            }else {
                return null;
            }
        },
        part1Norm() {
            if(this.part1Data.constructor === Object) {
                return this.part1Data.norm.slice(0,9);
            }else {
                return null;
            }
        },
        part3StrategyNorm() {
            if(this.part3Strategy.constructor === Object) {
                return this.part3Strategy.norm.slice(0,11);
            }else {
                return null;
            }
        },
  },
  created() {},
  mounted() {
    this.getStudentId();
  },
  methods: {
      getPartIndex() {
            let isHadReport = false;
            let data1 = this.part1Data;
            let data2 = this.part2Data;
            let data3 = this.part3Strategy;
            let data4 = this.part4Data;
            let list = this.list;
            let partIndex = 0;
            this.isHadReport = true;
            this.listData = this.list;
            // if(data1.constructor === Object) {
            //   isHadReport = true;
            //   partIndex ++;
            //   this.part1Index = partIndex;
            //   this.listData.push(list[0]);
            // }
            // if(data2.constructor === Object) {
            //   isHadReport = true;
            //   partIndex ++;
            //   this.part2Index = partIndex;
            //   this.listData.push(list[1]);
            //
            // }
            // if(data3.constructor === Object) {
            //   isHadReport = true;
            //   partIndex ++;
            //   this.part3Index = partIndex;
            //   this.listData.push(list[2]);
            // }
            // if(data4.constructor === Object) {
            //   isHadReport = true;
            //   partIndex ++;
            //   this.part4Index = partIndex;
            //   this.listData.push(list[3])
            // }
            // this.isHadReport = isHadReport;
        },
    // 获取信息
    getStudentId() {
      this.$ajax
        .post(
          this.G_acapi + this.ports.consultant.student.interView.getLearning,
          {
            studentId:this.studentId
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          let data = res.data.data;
          this.userName = data.username,
          this.version = data.version,
          this.SchoolId = data.agentHighSchoolId;
          this.getStudentinformation();
        });
    },
    // 获取报告
    getStudentinformation() {
      this.$ajax
        .post(
          this.G_lcapi + "/v1_c/report/getDataByUserInfo",
          {
            userName: this.userName,
            schoolID: this.SchoolId,
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          console.log(res,'报告')
           let data = res.data.result.data;        
          if (res.data.result.user.length==0) {           
            this.reportId = false;
            return false
          } else {

            this.reportId = true;
            // let updated_at = this.getReportDate(res.data.result.user.updated_at);
            this.reportData = data;
            this.user = res.data.result.user;
            this.core = res.data.result.core;
            this.normData = res.data.result.norm;
            this.reliability_index = res.data.result.reliability_index;
            this.part1Data = data[1];
            this.part2Data = data[2];
            this.part3Strategy = data[3].strategy;
            this.part3style = data[3].style;
            this.part4Data = data[4];
            this.total = data.total;
            
          }
        });
    },
    

    
  },
};
</script>
<!-- <style type="text/css" lang='less' scoped>
	@import './components/report.less';
</style> -->
<style type="text/css" lang='less' scoped>
.evaluationPeport_main {
  margin: 0 auto;
  background: #fff;
  padding: 20px 85px 50px;
}
.title {
  font-size: 32px;
  font-weight: bolder;
  line-height: 80px;
  text-align: center;
  color: #0094ea;
}
.partTitle {
  font-size: 20px;
  color: #2f2f2f;
  font-weight: bolder;
  padding: 30px 0;
  padding-bottom: 0;
}
.line {
  margin-top: 7px;
  height: 2px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#ffb23a),
    to(#19afbf)
  );
  background: linear-gradient(90deg, #ffb23a, #19afbf);
}
table {
  margin-top: 13px;
  margin-bottom: 38px;
  tr {
    line-height: 45px;
    th {
      width: 130px;
      text-align: center;
      border: 1px solid #dfdede;
      font-size: 14px;
      font-weight: bold;
      background: #f9f8f8;
    }
    td {
      border: 1px solid #dfdede;
      font-size: 12px;
      padding-left: 10px;
    }
  }
}
// 核心结果样式
.page_header {
  color: #fff;
  background-color: #f6a724;
  font-size: 24px;
  text-align: left;
  margin-bottom: 30px;
  line-height: 50px;
  padding-left: 30px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
.arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-left: 14px solid #feae3b;
  border-bottom: 9px solid transparent;
  border-left: 14px solid #feae3b;
}
.page_title_3_0 {
  height: 22px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 700;
  padding-top: 10px;
}
.color1 {
  color: #ff0000;
}
.color2 {
  color: #ffc001;
}
.color3 {
  color: #1ca4b6;
}
.color4 {
  color: #92d050;
}
.color5 {
  color: #00b050;
}
.part_detail {
  line-height: 32px;
  margin-bottom: 20px;
}
.part_detail span {
  font-size: 18px;
  font-weight: 700;
}
/deep/.buchongs{
    margin-bottom: 38px;  
    textarea {
     min-height: 140px !important;
    }  
}
</style>
